export enum TAGS {
  WONDR = 'wondr',
  ZOCDOC = 'zocdoc',
  ZOCDOC_GLP_1 = 'zocdoc-glp1',
  THRIVE = 'thrive',
  SWEATCOIN = 'sweatcoin',
  LOSE_IT = 'lose-it',
  MAN_VS = 'man-vs',
  MAYO = 'mayo',
  GAIA = 'gaia',
  GLP_1 = 'GLP-1',
  PRE_GLP_1 = 'PRE-GLP-1',
  CHARLIE_HEALTH = 'charlie-health',
  FERTILITY = 'Fertility',
  PREGNANCY_AND_POSTPARTUM = 'Pregnancy or Postpartum',
  HEART_HEALTH = 'Heart Health',
  DIABETES_OR_PREDIABETES = 'Diabetes or Prediabetes',
  FACTOR = 'Factor',
  SIGNOS = 'Signos',
  MBIOTA = 'mBIOTA',
  LINGO = 'Lingo by Abbott',
  WALMART = 'Walmart',
}

/** Healthie tag names (lowercase) mapped to display labels for partner badges. */
export const PARTNER_TAG_DISPLAY_NAMES: Record<string, string> = {
  [TAGS.FACTOR.toLowerCase()]: 'Factor',
  [TAGS.MAYO.toLowerCase()]: 'Mayo',
  [TAGS.SIGNOS.toLowerCase()]: 'Signos',
  [TAGS.MBIOTA.toLowerCase()]: 'mBIOTA',
  [TAGS.LINGO.toLowerCase()]: 'Lingo',
  [TAGS.WALMART.toLowerCase()]: 'Walmart',
};

/** Healthie tag names (lowercase) mapped to partner orientation/FAQ URLs. */
export const PARTNER_TAG_LINKS: Record<string, string> = {
  [TAGS.FACTOR.toLowerCase()]:
    'https://community.berrystreet.co/c/partnerships/sections/1000529/lessons/3812518',
  [TAGS.MAYO.toLowerCase()]:
    'https://docs.google.com/document/d/1VatI5o5aMMwFmioImqHa22EsanT1vOKhPtK_-YTovG8/edit?tab=t.0#heading=h.gpndnyvhwvjd',
  [TAGS.SIGNOS.toLowerCase()]:
    'https://community.berrystreet.co/c/mayo-clinic/new-partnership-signos-is-now-live',
  [TAGS.MBIOTA.toLowerCase()]:
    'https://community.berrystreet.co/c/mayo-clinic/new-partnership-welcome-mbiota',
  [TAGS.LINGO.toLowerCase()]:
    'https://community.berrystreet.co/c/partnership-announcements/lingo-cgm-partnership',
  [TAGS.WALMART.toLowerCase()]:
    'https://community.berrystreet.co/c/partnerships/sections/1115622/lessons/4251795',
};

export const GLP_SET = new Set<string | undefined>([
  TAGS.GLP_1,
  TAGS.PRE_GLP_1,
]);

export const tagsForTemplates = new Set<string>([
  TAGS.FERTILITY,
  TAGS.PREGNANCY_AND_POSTPARTUM,
  TAGS.GLP_1,
  TAGS.PRE_GLP_1,
  TAGS.HEART_HEALTH,
  TAGS.DIABETES_OR_PREDIABETES,
]);

export const PATIENT_PROGRAM_ALLOWED_TAGS: string[] = [
  TAGS.WONDR,
  TAGS.ZOCDOC,
  TAGS.THRIVE,
  TAGS.SWEATCOIN,
  TAGS.LOSE_IT,
  TAGS.MAN_VS,
  TAGS.MAYO,
  TAGS.GAIA,
  TAGS.GLP_1,
  TAGS.PRE_GLP_1,
  TAGS.CHARLIE_HEALTH,
  TAGS.FERTILITY,
  TAGS.PREGNANCY_AND_POSTPARTUM,
  TAGS.HEART_HEALTH,
  TAGS.DIABETES_OR_PREDIABETES,
];
